import { render } from "./CookiesAlert.vue?vue&type=template&id=7674dd6a&scoped=true&ts=true"
import script from "./CookiesAlert.vue?vue&type=script&scoped=true&lang=ts"
export * from "./CookiesAlert.vue?vue&type=script&scoped=true&lang=ts"

import "./CookiesAlert.vue?vue&type=style&index=0&id=7674dd6a&lang=sass&scoped=true"
/* custom blocks */
import block0 from "./CookiesAlert.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7674dd6a"]])

export default __exports__